import axios from 'axios'
import {
  Message
} from 'element-ui'

import cookie from 'js-cookie'
// axios.defaults.withCredentials = true 
const service = axios.create({
  baseURL: process.env.NODE_ENV==='development'?'':location.origin,
  timeout: 5000,
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded'
  },
  transformRequest: [function (data) {
    let ret = ''
    for (let it in data) {
      ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
    }
    return ret
  }],
});


// 添加请求拦截器
service.interceptors.request.use(function (config) {
  const portalToken= cookie.get('portalToken')||''
  if (portalToken) config.headers['portaltoken'] = portalToken 
  return config;
}, function (error) {
  return Promise.reject(error);
});

// 添加响应拦截器
service.interceptors.response.use(function (response) {
  if(response.data.code==0){
    Message.error(response.data.msg);
  }
  return response.data;
}, function (error) {
  // 对响应错误做点什么
  if (error.message == "Network Error") {
    Message.error('网络异常！');
  } else if (error.message == "timeout") {
    Message.error('链接超时！');
  } else if (error.message.indexOf('404') != -1) {
    Message.error('网络资源未找到');
  } else {
    Message.error('链接失败！');
  }
  return Promise.reject(error);
});

export default service
